import { AccessDeniedError } from '../../../domain/errors/access-denied-error'
import { UnexpectedError } from '../../../domain/errors/unexpected-error'
import { UnprocessableEntityError } from '../../../domain/errors/unprocessable-entity-error'
import { NotFound } from '../../../domain/errors/not-found'
import { CreateUser, CreateUserResponse } from '../../../domain/usecases/user/post-user'
import { HttpClient, HttpStatusCode } from '../../protocols/http/http-client'
export class RemoteCreateUser implements CreateUser {
  constructor (
    private readonly endpoint: string,
    private readonly httpClient: HttpClient<CreateUserResponse.Response>
  ) {}

  async post (body: any): Promise<CreateUserResponse.Response> {
    const httpResponse = await this.httpClient.request({
      url: this.endpoint,
      method: 'post',
      data: body
    })

    const remoteResult = httpResponse.body as CreateUserResponse.Response
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok: return remoteResult
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.badRequest: throw new NotFound(remoteResult)
      case HttpStatusCode.unprocessableEntity: throw new UnprocessableEntityError(remoteResult)
      default: throw new UnexpectedError()
    }
  }
}
